<template>
  <div>
    <delete-button @click="dialog = true"></delete-button>
    <b-modal
      tabindex="0"
      v-model="dialog"
      title="Recipient Delete Reason"
      hide-footer
      ignore-enforce-focus-selector=".select2-search__field"
      size="sm"
      centered
    >
      <form-wrapper @submit="submit">
        <b-row class="pb-0">
          <b-col cols="12">
            <div class="text-muted">UID</div>
            <div class="h6">{{item.recipient_registration_id}}</div>
          </b-col>
          <b-col cols="12" class="mt-2">
            <div class="text-muted">Recipient Name</div>
            <div class="h6">{{item.first_name}}</div>
          </b-col>
          <b-col cols="12" class="mt-2">
            <select-field
              label="Reason"
              :items="reasons"
              rules="required"
              v-model="delete_reason"
            ></select-field>
            <input-field v-if="isOther" label="Notes" rules="required" v-model="reason">
            </input-field>
          </b-col>
        </b-row>
        <div class="d-flex">
          <div class="flex-grow-1"></div>
          <b-button variant="outline-danger mx-3" @click="dialog = false"
            >Cancel
          </b-button>
          <b-button variant="success" type="submit">Submit </b-button>
        </div>
      </form-wrapper>
    </b-modal>
  </div>
</template>

<script>
import recipientService from "../../assets/services/recipient.service";
import DeleteButton from "../buttons/DeleteButton.vue";
import SelectField from "../form/SelectField.vue";
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
    reasons: {
      type: Array,
      default: () => [],
    },
  },
  components: { DeleteButton, SelectField },
  data() {
    return {
      dialog: false,
      reason: "",
      delete_reason: "",
    };
  },
  computed: {
    isOther() {
      return this.delete_reason.trim() == "Others";
    },
  },
  methods: {
    async submit() {
      const vm = this;
      try {
        vm.$loader.show();
        let { recipient_registrationid } = vm.item;
        let reason = vm.delete_reason;
        if (vm.isOther) reason = vm.reason;
        let doc = {
          recipient_registration_id: recipient_registrationid,
          delete_reason: reason,
          dml_indicator: "D",
          transtan_status: "5",
        };
        let { status, msg } = (await recipientService.deleteReason(doc)).data;
        vm.$emit("fetch");
        if (status) {
          vm.dialog = false;
        } else {
          vm.$alert.show(msg);
        }
        vm.$loader.hide();
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
  },
};
</script>

<style></style>
